"use client";
import {
  skeleton_default
} from "./chunk-TLYTI3QM.mjs";
import {
  useSkeleton
} from "./chunk-XB6FZTQR.mjs";
export {
  skeleton_default as Skeleton,
  useSkeleton
};
